import { Injectable } from '@angular/core';
import { System } from '@app/core/resources/system';

@Injectable({
    providedIn: 'root'
})
export class WebSocketSystemUpdaterService {
    public updateSystems(
        eventData: any,
        systemsCanSend: Array<System>,
        systemsCanReceive: Array<System>,
        onSpecialSystemUpdate?: (system: System) => void
    ): void {
        systemsCanSend.forEach((systemSend: System): void => {
            const systemUpdateSend: System | null =
                eventData.eventData.find((systemEvent: System) => systemEvent.id === systemSend.id) || null;
            if (systemUpdateSend) {
                onSpecialSystemUpdate?.(systemUpdateSend);
                systemSend.fill(systemUpdateSend.toObject());
            }
        });

        systemsCanReceive.forEach((systemReceive: System): void => {
            const systemUpdateReceive: System | null =
                eventData.eventData.find((systemEvent: System) => systemEvent.id === systemReceive.id) || null;
            if (systemUpdateReceive) {
                systemReceive.fill(systemUpdateReceive.toObject());
            }
        });
    }
}
